import { render, staticRenderFns } from "./CSVDownload.vue?vue&type=template&id=92528a0c&lang=pug"
import script from "./CSVDownload.vue?vue&type=script&lang=js"
export * from "./CSVDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports